import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modFields", "valueFields"];
  static values = { operator: String };

  operatorChanged(event) {
    this.operatorValue = event.target.value;
  }

  operatorValueChanged() {
    const isMod = this.operatorValue === "mod";

    if (this.hasModFieldsTarget) {
      this.modFieldsTarget.classList.toggle("hidden", !isMod);
      this.modFieldsTarget.querySelectorAll("input, select").forEach((el) => {
        el.disabled = !isMod;
      });
    }
    if (this.hasValueFieldsTarget) {
      this.valueFieldsTarget.classList.toggle("hidden", isMod);
      this.valueFieldsTarget.querySelectorAll("input, select").forEach((el) => {
        el.disabled = isMod;
      });
    }
  }
}
